/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewZoomyAccountDomainConfidenceMap } from './CRSFSecReviewZoomyAccountDomainConfidenceMap';
import {
    CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSON,
    CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSONTyped,
    CRSFSecReviewZoomyAccountDomainConfidenceMapToJSON,
} from './CRSFSecReviewZoomyAccountDomainConfidenceMap';

/**
 * Model that holds all domain confidence scores gathered for each account and automation domains.
 * @export
 * @interface CRSFSecReviewZoomyDomainConfidenceMapList
 */
export interface CRSFSecReviewZoomyDomainConfidenceMapList {
    /**
     * 
     * @type {Array<CRSFSecReviewZoomyAccountDomainConfidenceMap>}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapList
     */
    confidence_map_list: Array<CRSFSecReviewZoomyAccountDomainConfidenceMap>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapList
     */
    confidence_thresholds: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapList
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFSecReviewZoomyDomainConfidenceMapList interface.
 */
export function instanceOfCRSFSecReviewZoomyDomainConfidenceMapList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidence_map_list" in value;
    isInstance = isInstance && "confidence_thresholds" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFSecReviewZoomyDomainConfidenceMapListFromJSON(json: any): CRSFSecReviewZoomyDomainConfidenceMapList {
    return CRSFSecReviewZoomyDomainConfidenceMapListFromJSONTyped(json, false);
}

export function CRSFSecReviewZoomyDomainConfidenceMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewZoomyDomainConfidenceMapList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidence_map_list': ((json['confidence_map_list'] as Array<any>).map(CRSFSecReviewZoomyAccountDomainConfidenceMapFromJSON)),
        'confidence_thresholds': json['confidence_thresholds'],
        'version': json['version'],
    };
}

export function CRSFSecReviewZoomyDomainConfidenceMapListToJSON(value?: CRSFSecReviewZoomyDomainConfidenceMapList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence_map_list': ((value.confidence_map_list as Array<any>).map(CRSFSecReviewZoomyAccountDomainConfidenceMapToJSON)),
        'confidence_thresholds': value.confidence_thresholds,
        'version': value.version,
    };
}

